import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import types from 'helpers/constants';

export const TranslatableObjectKey = '@ContentTranslation';

export const useTranslatableSelectedLanguage = () =>
  useSelector(root => root.Translatable.selectedLanguage ?? 'pl', shallowEqual);

export const useTranslatableLanguageHandler = () => {
  const dispatch = useDispatch();

  return (e, obj) => {
    dispatch({
      type: types.TRANSLATABLE_SELECT_LANGUAGE,
      payload: {
        selectedLanguage: obj.lang,
      },
    });
  };
};

export const useTranslatableLanguages = () =>
  useSelector(root => {
    const stateLanguages =
      root.Auth.languages.filter(lang => lang.enabledForClient) || [];

    return (
      stateLanguages.length === 0 ? [{ isoCode: 'pl' }] : stateLanguages
    ).map(el => el.isoCode);
  }, shallowEqual);

export const compareTranslatableValues = (val1, val2) =>
  JSON.stringify(val1) === JSON.stringify(val2);

export const isTranslatableLangIdenticalInTwoObjects = (val1, val2, lang) =>
  (val1?.[TranslatableObjectKey]?.[lang] || null) ===
  (val2?.[TranslatableObjectKey]?.[lang] || null);

export const isTranslatableValuesObjectEmpty = value => {
  if (!value) {
    return true;
  }

  const translations = Object.keys(value[TranslatableObjectKey] || {});

  return (
    Object.keys(translations).filter(el => !translations[el]).length ===
    Object.keys(translations).length
  );
};

export const isTranslatableLangEmpty = (value, lang) => {
  if (!value) {
    return true;
  }

  return !value[TranslatableObjectKey]?.[lang];
};

export const useGetCompanyDefaultLanguage = () =>
  useSelector(root => root.Company?.language || 'pl');

export default useTranslatableSelectedLanguage;
